import React from "react";
import { NavLink } from "react-router-dom";
import {
 
  FaLocationDot,
  FaPhone,
  FaRegEnvelope,
  FaLinkedinIn,
} from "react-icons/fa6";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaWhatsapp
} from "react-icons/fa";

const Footer = () => {
  // Function to handle WhatsApp click
  const handleWhatsAppClick = () => {
    const phoneNumber = '7701885426';
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const whatsappUrl = isMobile 
      ? `whatsapp://send?phone=${phoneNumber}` 
      : `https://web.whatsapp.com/send?phone=${phoneNumber}`;
    
    window.open(whatsappUrl, '_blank');
  };

  return (
    <footer>
      <div className="container py-5">
        <div className="row">
          <div className="col-md-3">
            <div className="footer-wrapper">
              <div className="wrapper">
                <div className="footer-logo">
                  <img src="/images/logo2.png" alt="logo" />
                </div>

                <div className="icon-list">
                  <a
                    href="https://www.facebook.com/integratedinterior"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="icon"
                  >
                    <FaFacebookF />
                  </a>
                  <a
                    href="https://www.facebook.com/share/1B4kCQoBtu/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="icon"
                  >
                    <FaTwitter />
                  </a>
                  <a
                    href="https://www.instagram.com/integratedelegance?igsh=MWRid2R0c25teGRy&utm_source=qr"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="icon"
                  >
                    <FaInstagram />
                  </a>
                  <button
                    onClick={handleWhatsAppClick}
                    className="icon"
                    
                  >
                    <FaWhatsapp />
                  </button>
                  <a
                    href="https://www.linkedin.com/company/integrated-interior"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="icon"
                  >
                    <FaLinkedinIn />
                  </a>
                </div>
              </div>
              <div className="img-iso mb-4 mb-md-0">
                <h6>ISO 9001 : 2015 certified company</h6>
                <img src="./images/iso.png" alt="" />
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="footer-wrapper">
              <div className="wrapper">
                <h4>Contact us</h4>
                <ul className="ps-0">
                  <li className="d-flex mt-4">
                    <span className="icon-box me-2">
                      <FaLocationDot />
                    </span>
                    <span>
                      <p className="">
                      A 87, Sector 69, Noida, Uttar Pradesh -201301
                      </p>
                    </span>
                  </li>

                  <li>
                    <span className="icon-box me-2">
                      <FaPhone />
                    </span>
                    <NavLink
                      className="effect effect-white"
                      to="tel:+917701885426"
                    >
                      {" "}
                      +91 77018 85426
                    </NavLink>
                  </li>
                  <li>
                    <span className="icon-box me-2">
                      <FaRegEnvelope />
                    </span>
                    <NavLink
                      className="effect effect-white"
                      to="mailto:info@integratedinterior.com"
                      target="_blank"
                      rel="noopener"
                    >
                      info@integratedinterior.com
                    </NavLink>{" "}
                    <br /> <br />
                  </li>
                  
                </ul>
                <ul className="mt-4">
                  <li>
                    <NavLink to="term-condition">Term & Condition</NavLink>
                  </li>
                  <li>
                    <NavLink to="privacy-policy">Privacy Policy</NavLink>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-5">
            <h4>Our Location</h4>
            <div className="wrapper">
          
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2768.3979945403394!2d77.3895724754999!3d28.609228875677516!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjjCsDM2JzMzLjIiTiA3N8KwMjMnMzEuNyJF!5e1!3m2!1sen!2sin!4v1736013569122!5m2!1sen!2sin"
                width="100%"
                height="350"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      <div className="copyright">
        <div className="container">
          <p className="text-center mb-0">
            Copyright© 2024 Integrated Interior - All Rights Reserved.
          </p>
        </div>
      </div>




        <button className="whatsaap-button text-white" onClick={handleWhatsAppClick}>
          <FaWhatsapp  style={{fontSize:25}}/> <span className="ms-2"> How can i help you?</span>
        </button>
      
    </footer>
  )
};

export default Footer;